import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ArrowLeft } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";
import { useMitt } from "@/context/shared/eventBus";
export var Header = function () {
    var mitt = useMitt();
    var _a = useState(), pageData = _a[0], setPageData = _a[1];
    var navigate = useNavigate();
    useEffect(function () {
        var pageDataChange = function (data) {
            setPageData(data);
        };
        mitt.on("pageData", pageDataChange);
        return function () { return mitt.off("pageData", pageDataChange); };
    }, []);
    return (_jsx("div", { className: "header", children: _jsxs(Flex, { gap: 2, justifyContent: "space-between", alignItems: "center", style: { minHeight: 44 }, children: [!!(pageData === null || pageData === void 0 ? void 0 : pageData.backLink) && (_jsx(Button, { size: "xl", view: "flat", onClick: function () { return navigate(pageData.backLink); }, children: _jsx(Icon, { data: ArrowLeft, size: 24 }) })), _jsx(Text, { variant: "header-2", children: pageData === null || pageData === void 0 ? void 0 : pageData.title })] }) }));
};
